import { ChefHat } from 'lucide-react'
import { cn, getDifficultyAccentClass, getDifficultyLevel } from '@/lib/utils'

interface DifficultyIndicatorProps {
  difficulty?: string | null
  showLabel?: boolean
  className?: string
}

export function DifficultyIndicator({
  difficulty,
  showLabel = true,
  className,
}: DifficultyIndicatorProps) {
  const level = getDifficultyLevel(difficulty)
  const accentClass = getDifficultyAccentClass(difficulty)

  if (!difficulty) {
    return null
  }

  return (
    <div className={cn('inline-flex items-center gap-2', className)}>
      <div className="flex items-center gap-0.5" aria-label={`Moeilijkheid ${difficulty}`}>
        {Array.from({ length: 5 }).map((_, index) => (
          <ChefHat
            key={index}
            className={cn(
              'h-4 w-4 transition-colors',
              index < level ? accentClass : 'text-gray-400 dark:text-slate-400'
            )}
          />
        ))}
      </div>
      {showLabel ? (
        <span className="text-sm font-medium capitalize text-gray-700 dark:text-slate-100">{difficulty}</span>
      ) : null}
    </div>
  )
}
